module.exports = __webpack_public_path__ + "img/qijian.af47a54f.svg";